import { Button } from "antd";
import { EditSvg } from "components/Icon";

const MediActionEdit = (props) => {
  const handleClick = (e) => {
    if (props.onClick) {
      props.onClick(e);
    }
  };

  return (
    <Button
      {...props}
      icon={<EditSvg color={props.color || "#8D8D8D"} />}
      onClick={handleClick}
      type="text"
    >
      {props.children}
    </Button>
  );
};

export default MediActionEdit;
